import { axios } from "../../../library/axios"

export const refundMagento = (orderData: any) => {
    return axios.put('/administration/refund-magento', orderData)
}